module.exports = __webpack_public_path__ + "static/media/status_2.fcb4bc74.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/collectionOnline/images/status_2.png
// module id = 622
// module chunks = 0